import { render, staticRenderFns } from "./InterpreterDetailDialog.vue?vue&type=template&id=5502c20e&scoped=true"
import script from "./InterpreterDetailDialog.vue?vue&type=script&lang=js"
export * from "./InterpreterDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5502c20e",
  null
  
)

export default component.exports